import { Checkbox, FormControlLabel } from '@material-ui/core';
import React from 'react';
import { Container } from './styles';

interface OptionProps {
  name: string;
  id: number;
  handleSelection: (value: number) => void;
  selected: number[];
}

export function Option({ name, id, handleSelection, selected }: OptionProps) {
  return (
    <FormControlLabel
      control={
        <Checkbox 
          checked={selected.includes(id)} 
          onChange={() => handleSelection(id)} 
          name="checkedA" 
        />
      }
      label={name}
    />
  );
}